module.exports = __webpack_public_path__ + "img/active-layer1.297b90fe.png";